export default __webpack_public_path__ + "static/media/dropup-arrow.19c27375.svg";